import { CLAIM_KEYS } from '../constants/authorization.constants';
import type { AuthorizationContext } from '../models/authorization-context.model';

/**
 * Extract roles, permissions, and raw claims from a customAccessToken claims record. Missing claims produce empty
 * arrays — never throw, always deny-by-default.
 */
export function parseAuthorizationContext(
  claims: Record<string, unknown>,
  source = 'customAccessToken'
): AuthorizationContext {
  const roles = normalizeStringArray(claims[CLAIM_KEYS.ROLES]);
  const permissions = normalizeStringArray(claims[CLAIM_KEYS.PERMISSIONS]);

  return { roles, permissions, claims, source };
}

/**
 * Coerces a raw claim value into a string array. Handles claims that arrive as a proper array, a single space-delimited
 * string (e.g. OAuth scope-style claims), or a lone value — never spreads a raw string into individual characters,
 * which silently corrupts single-permission claims.
 */
export function normalizeStringArray(value: unknown): string[] {
  if (Array.isArray(value)) {
    return value.filter((v): v is string => typeof v === 'string');
  }
  if (typeof value === 'string' && value.length > 0) {
    return value.split(' ').filter(Boolean);
  }
  return [];
}
